import { render, staticRenderFns } from "./editPwd.vue?vue&type=template&id=0cc70ed8&scoped=true"
import script from "./editPwd.vue?vue&type=script&lang=js"
export * from "./editPwd.vue?vue&type=script&lang=js"
import style0 from "./editPwd.vue?vue&type=style&index=0&id=0cc70ed8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc70ed8",
  null
  
)

export default component.exports